import React from "react";
import { Import } from "../Import/Import";
import { Export } from "../Export/Export";
import { Draw } from "./Draw";
import { WmsAddition } from "../WMS/WmsAddition";
import { WmsContextProvider } from "../../Contexts/WmsContext";
import "./DrawWidget.scss";

export const DrawingWidget = (): JSX.Element => (
    <div className="scrollable-content-container">
        <div className="scrollable-content">
            <Import />
            <Export />
            <Draw />
            <WmsContextProvider>
                <WmsAddition />
            </WmsContextProvider>
        </div>
    </div>
);
